module.exports = __webpack_public_path__ + "static/media/jifenzhishenpi.b75666da.png";